module.exports = __webpack_public_path__ + "img/tlf_dep.04129315.svg";